import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CanadianWorkersCompensationStatus } from 'src/app/interfaces/canadian-workers-compensation-status';
import { CanadianWorkersCompensationType } from 'src/app/interfaces/canadian-workers-compensation-type';

export class CanadianWorkersCompensationForm extends FormGroup<{
  id: FormControl<number | undefined>;
  CompanyVendorId: FormControl<number | undefined>;
  CompanyId: FormControl<number | undefined>;
  VendorId: FormControl<number | undefined>;
  type: FormControl<CanadianWorkersCompensationType | undefined>;
  CAWCNumber: FormControl<string | null>;
  CAWCcertNumber: FormControl<string | null>;
  CAWCStatus: FormControl<CanadianWorkersCompensationStatus | null>;
  CAWCDate: FormControl<Date | null>;
  CAWCExempt: FormControl<boolean>;
}> {
  constructor() {
    super({
      id: new FormControl<number | undefined>(undefined, { nonNullable: true }),
      CompanyVendorId: new FormControl<number | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      CompanyId: new FormControl<number | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      VendorId: new FormControl<number | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      type: new FormControl<CanadianWorkersCompensationType | undefined>(
        undefined,
        { nonNullable: true }
      ),
      CAWCNumber: new FormControl<string | null>(null, {
        validators: [Validators.required]
      }),
      CAWCcertNumber: new FormControl<string | null>(null),
      CAWCStatus: new FormControl<CanadianWorkersCompensationStatus | null>(
        null,
        { validators: [Validators.required] }
      ),
      CAWCDate: new FormControl<Date | null>(null, {
        validators: [Validators.required]
      }),
      CAWCExempt: new FormControl<boolean>(false, {
        nonNullable: true,
        validators: [Validators.required]
      })
    });
  }
}
